import type { IconType } from '@ng-icons/core';

import {
  heroArrowDownTray,
  heroCheckBadge,
  heroInformationCircle,
  heroXMark,
  heroPencil,
  heroUsers,
  heroPlus,
  heroTrash,
  heroArrowUpRight,
  heroPlusCircle,
} from '@ng-icons/heroicons/outline';

export const AppIcons: { [key: string]: IconType } = {
  heroArrowDownTray,
  heroInformationCircle,
  heroCheckBadge,
  heroXMark,
  heroPencil,
  heroUsers,
  heroPlus,
  heroTrash,
  heroArrowUpRight,
  heroPlusCircle,
};
